export const DevAppEnvironments = [
  'local',
  'dev',
  'qa',
  'qa2',
  'qa3',
  'demo'
];